import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const VinInputWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const BarcodeContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1000;
  font-size: 26px;
  
  @media (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`;

export const MakeModelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MakeModel = styled.div`
  > span {
    margin-left: 15px;
    font-size: 1.1rem;
    font-family: 'Roboto', sans-serif;
  }
`;

export const Row = styled.div`
  flex-direction: row;
  display: flex;
  margin: 5px;
  justify-content: center;
`;
